<avano-button-bar [buttonsData]="buttonBarButtons"></avano-button-bar>
<div class="avano-content-area table-with-search">
  <div class="search-panel-product search-panel">
    <scip-products-table-search></scip-products-table-search>
  </div>
  <div class="table-panel">
    <scip-products-table [loadingInfo]="loadingInfo"></scip-products-table>
  </div>
</div>

<!-- Edit Products Dialog -->
<scip-edit-product *ngIf="showEditDialog" [products]="selectedProducts" (closeEvent)="closeEditProductDialog($event)"></scip-edit-product>
<!-- Dossier Upload Dialog -->
<scip-upload-product-dialog
  *ngIf="showDossierUploadDialog"
  [products]="selectedProducts"
  (closeEvent)="closeDossierUploadDialog($event)"
></scip-upload-product-dialog>
